import { render, staticRenderFns } from "./UsersMainList.vue?vue&type=template&id=50f8a712&"
import script from "./UsersMainList.vue?vue&type=script&lang=js&"
export * from "./UsersMainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports